import { render } from "./retailerstable.vue?vue&type=template&id=e5341196&scoped=true"
import script from "./retailerstable.vue?vue&type=script&lang=js"
export * from "./retailerstable.vue?vue&type=script&lang=js"

import "./retailerstable.vue?vue&type=style&index=0&id=e5341196&scoped=true&lang=css"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5341196"]])

export default __exports__